import { LoadingSpinner, PaginationState } from '@psyomics/ui-components';
import { useState } from 'react';

import { ReferralUploadJobsView } from './referral-upload-jobs-view';
import { useReferralUploadJobsQuery } from './use-referral-upload-jobs';

const PAGE_SIZE = 10;
const DEFAULT_PAGINATION: PaginationState = { pageIndex: 0, pageSize: PAGE_SIZE };

const ReferralUploadJobs = () => {
  const [pagination, setPagination] = useState<PaginationState>(DEFAULT_PAGINATION);
  const { result } = useReferralUploadJobsQuery({
    pageIndex: pagination.pageIndex,
    pageSize: pagination.pageSize,
  });

  if (!result) return <LoadingSpinner />;

  return (
    <ReferralUploadJobsView
      jobs={result.jobs}
      onPaginationChange={setPagination}
      pagination={pagination}
      totalCount={result.totalCount}
    />
  );
};

export { ReferralUploadJobs };
